import { useQueryClient } from '@tanstack/react-query'

export const useInvalidateScheduledTasks = () => {
  const queryClient = useQueryClient()
  return () => {
    queryClient.invalidateQueries({ queryKey: ['logs/scheduled-tasks'] })
  }
}
